import React from 'react';
import * as Style from './IconAlertTriangle.style';

const IconAlertTriangle = ({
  color = '#FF9442',
  testId = 'icon-alert-triangle',
  size = '20',
}) => (
  <Style.Wrapper data-testid={testId}>
    <svg xmlns="http:// www.w3.org/2000/svg" width={size} fill="none" height={size} viewBox="0 0 21 20">
      <path d="M10.4997 7.49995V10.8333M10.4997 14.1666H10.508M9.34576 3.24305L2.49166 15.0819C2.11149 15.7385 1.92141 16.0669 1.9495 16.3364C1.97401 16.5714 2.09715 16.785 2.28828 16.924C2.50741 17.0833 2.8868 17.0833 3.64556 17.0833H17.3537C18.1125 17.0833 18.4918 17.0833 18.711 16.924C18.9021 16.785 19.0253 16.5714 19.0498 16.3364C19.0778 16.0669 18.8878 15.7385 18.5076 15.0819L11.6535 3.24305C11.2748 2.58874 11.0853 2.26159 10.8383 2.15172C10.6227 2.05587 10.3766 2.05587 10.1611 2.15172C9.91392 2.26159 9.72451 2.58875 9.34576 3.24305Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </Style.Wrapper>
);


export default IconAlertTriangle;
